export const ALL_STATUSES = [
    'NEW',
    'IN_PROGRESS',
    'CLOSED',
    'CLOSED_WITHOUT_ACTION',
    'RE_OPEN',
] as const;

export type CarReportStatus = (typeof ALL_STATUSES)[number];

export const STATUS_LABELS: Record<CarReportStatus, string> = {
    NEW: 'New',
    IN_PROGRESS: 'In progress',
    CLOSED: 'Closed',
    CLOSED_WITHOUT_ACTION: 'Closed w/o action',
    RE_OPEN: 'Re-open',
};

export const STATUS_TRANSITIONS: Record<CarReportStatus, CarReportStatus[]> = {
    NEW: ['IN_PROGRESS', 'CLOSED_WITHOUT_ACTION'],
    IN_PROGRESS: ['CLOSED'],
    CLOSED: ['RE_OPEN'],
    RE_OPEN: ['IN_PROGRESS'],
    CLOSED_WITHOUT_ACTION: [],
};

export const normalizeStatus = (raw?: string | null): CarReportStatus => {
    if (!raw) return 'NEW';

    const text = raw.trim();

    const upper = text.toUpperCase().replace(/[\s\-\/]+/g, '_');
    if ((ALL_STATUSES as readonly string[]).includes(upper)) {
        return upper as CarReportStatus;
    }

    const labelEntry = (Object.entries(STATUS_LABELS) as [CarReportStatus, string][])
        .find(([, label]) => label.toLowerCase() === text.toLowerCase());
    if (labelEntry) {
        return labelEntry[0];
    }

    if (text.toLowerCase() === 'closed w/o action') {
        return 'CLOSED_WITHOUT_ACTION';
    }

    return 'NEW';
};
